//Some shortcuts for functions
/**
 *
 */
function nextSlide() {
	Reveal.right();
}

/**
 *
 */
function prevSlide() {
	Reveal.left();
}

/**
 *
 */
function downSlide() {
	Reveal.down();
}

/**
 *
 */
function upSlide() {
	Reveal.up();
}

/**
 *
 */
function nextHide() {
	$('#si-next').hide();
}

/**
 *
 */
function nextShow() {
	$('#si-next').show();
}

/**
 *
 */
function backHide() {
	$('#si-back').hide();
}

/**
 *
 */
function backShow() {
	$('#si-back').show();
}

/**
 * @param n
 */
function jumpToSlide(n) {
	Reveal.slide(n - 1);
}

/**
 * @param id
 */
function jumpToId(id) {
	var num = slides[id].slideNumber;
	Reveal.slide(num - 1);
}

/**
 * @param $element
 */
function lock($element) {
	$element.addClass('noEvents');
	$element.attr('disabled', 'disabled');
}

/**
 * @param $element
 */
function unlock($element) {
	$element.removeClass('noEvents');
	$element.removeAttr('disabled');
}

/**
 * @param pathName
 */
function setPath(pathName) {
	if (!checkWholePath(pathName) && lmsConnected) {
		setScormIncomplete();
	}
	return (saveData.pathSelected = pathName);
}

/**
 * @param input
 */
function getCompletionStatus(input) {
	if (Array.isArray(input))
		return input.every(function (slide) {
			return getCompletionStatus(slide);
		});

	var checkSpecificPath = input && input[0] === '@';

	if (checkSpecificPath) return checkWholePath(input.split('@')[1]);

	var slide = !input ? globalVar.slide : { id: input, data: slides[input], $: $('#' + input) };

	if (!slide.data) return console.warn('invalid slide');
	if (!slide.data.include) return; //console.warn('include: false');

	var onCurSlide = slide.id === globalVar.slide.id;
	var slideCompletion = saveData.slideCompletion;
	var pathSelected = saveData.pathSelected;
	var specifiedPath = slide.data.completionPath;
	var pathObj = slideCompletion.mainPath;

	if (specifiedPath) {
		if (Array.isArray(specifiedPath)) {
			if (pathSelected && specifiedPath.indexOf(pathSelected) >= 0) {
				pathObj = slideCompletion[pathSelected];
			} else {
				pathObj = slideCompletion[specifiedPath[0]];
				if (onCurSlide) setPath(specifiedPath[0]);
			}
		} else {
			pathObj = slideCompletion[specifiedPath];
			if (onCurSlide) setPath(specifiedPath);
		}
	}

	return pathObj[slide.id];
}

function checkWholePath(path) {
	var pathObj = saveData.slideCompletion[path];
	for (var key in pathObj) {
		if (!pathObj[key]) return 0;
	}
	return pathObj ? 1 : 0;
}

function completeSlide(input) {
	if (Array.isArray(input))
		return input.forEach(function (slideID) {
			completeSlide(slideID);
		});

	var slide = input ? getSlideHelpers(input) : globalVar.slide;

	if (!slide.data.include) return;

	var specifiedPath = slide.data.completionPath;
	var slideCompletion = saveData.slideCompletion;

	if (specifiedPath) {
		if (Array.isArray(specifiedPath)) {
			specifiedPath.forEach(function (path, idx) {
				slideCompletion[path][slide.id] = 1;
			});
		} else slideCompletion[specifiedPath][slide.id] = 1;
	} else slideCompletion.mainPath[slide.id] = 1;
}

/**
 * @param navElem
 * @param styleClass
 * @param styleClassInput
 * @param html
 */
function customNavStyle(navElem, styleClassInput, html) {
	var isIcon = navElem.indexOf('icon') !== -1;
	var elem = isIcon ? $('.si-helper-icon') : $('#si-' + navElem);
	var uninjectedSVG = elem.find('.inject-me:not(.injected-svg)');
	waitForSVGS(uninjectedSVG, function () {
		var slide = globalVar.slide;
		var initialHTML = elem.html();
		var defaultClass = slide.id + '-' + navElem;
		var styleClass = styleClassInput ? styleClassInput : defaultClass;

		if (html) elem.html(html);

		elem.addClass(styleClass);

		addToFunctionKey(slide.data, 'onExitAction', function () {
			elem.html(initialHTML);
			elem.removeClass(styleClass);
		});
	});
}

function addToFunctionKey(obj, functionKey, functionalityToAdd) {
	obj[functionKey] = (function () {
		var originalKey = obj[functionKey];
		return function () {
			if (originalKey) originalKey.apply(this);
			functionalityToAdd();
		};
	})();
}

/**
 * @param uninjectedSVGs
 * @param uninjectedSVG
 * @param doAfterWaiting
 */
function waitForSVGS(uninjectedSVG, doAfterWaiting) {
	if (uninjectedSVG.length > 0) {
		setTimeout(function () {
			var stillUninjectedSVGs = uninjectedSVG.parent().find('.inject-me:not(.injected-svg)');
			waitForSVGS(stillUninjectedSVGs, doAfterWaiting);
		}, 10);
	} else {
		doAfterWaiting();
	}
}

function slideAction(id, action) {
	var slide = getSlideHelpers(id);

	var hasMaster = typeof masterSlide !== 'undefined';
	var masterAction = hasMaster && masterSlide[action];

	var groups = Array.isArray(slide.data.groups) ? slide.data.groups : [slide.data.groups];
	var hasGroup = groups[0] !== undefined;

	var slideAction = slide.data[action];
	var startingSlide = slide.id;
	var sameSlide;

	masterAction && masterAction(slide);
	hasGroup &&
		groups.forEach(function (group) {
			return group[action] && group[action](slide);
		});
	slideAction && slideAction(slide);

	sameSlide = startingSlide === globalVar.slide.id;

	if (sameSlide) {
		switch (action) {
			case 'nextAction':
				nextSlide();
				break;
			case 'backAction':
				prevSlide();
				break;
		}
	}

	return masterAction || slideAction;
}

function addCoins(num) {
	var slide = globalVar.slide;
	var slideCoinData = saveData.coinScore[slide.id];
	var slideEarned = slideCoinData.earned || 0;
	var multiplier = slide.data.coinSettings.multiplier || 1;

	var curTotal = saveData.coinScore.totalScore || 0;

	if (slideEarned < multiplier) {
		slideCoinData.earned = multiplier;
		saveData.coinScore.totalScore = multiplier + curTotal;
		updateOnScreenTotal(saveData.coinScore.totalScore);
	} else return;
}
function addCoinForAnswer(answerId) {
	var slide = globalVar.slide;

	if (saveData.coinScore[slide.id][answerId]) {
		return;
	}
	var curTotal = saveData.coinScore.totalScore || 0;
	var individualMultipler = slides[slide.id].coinSettings.individualMultiplier || 1;
	saveData.coinScore[slide.id].earned = (saveData.coinScore[slide.id].earned || 0) + individualMultipler;
	saveData.coinScore[slide.id][answerId] = individualMultipler;
	saveData.coinScore.totalScore = curTotal + individualMultipler;
	updateOnScreenTotal(saveData.coinScore.totalScore);
}

function updateOnScreenTotal(total) {
	$('#coin-text').html(total);
}

function filterObj(obj, key, conditionFunc) {
	return Object.keys(obj)
		.filter(function (i) {
			return conditionFunc(obj[i][key]);
		})
		.reduce(rebuildObj(obj), {});
}
function rebuildObj(obj) {
	return function (rebuiltObj, key) {
		rebuiltObj[key] = JSON.parse(JSON.stringify(obj[key]));
		return rebuiltObj;
	};
}
function copyObj(obj) {
	return JSON.parse(JSON.stringify(obj));
}

function lockButtonNowUnlockOnExit($button, slideObj) {
	var slideObj = slideObj || globalVar.slide.data;

	lock($button);

	if (slideObj.visited) return;

	addToFunctionKey(slideObj, 'onExitAction', function () {
		unlock($button);
	});
}

function getSlideHelpers(id) {
	var id = id;
	return {
		id: id,
		$: $('#' + id),
		data: slides[id]
	};
}

////////////*Feature:idebehold///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function instaCheatAddon() {
	console.log("Hello, I'm your instaCheat™ addon for today!");
}

//the holy cheatfunction!!!
/**
 *
 */
function devMode() {
	var slide = globalVar.slide;
	// Cheat code. See Doom.

	$('body').addClass('dev-mode');
	console.log('GOD MODE!');
	$('#guidelines').show();

	$(document).keyup(function (e) {
		// 'g' key toggles grid lines
		if (e.which == 71) {
			if ($('#guidelines').css('display') != 'none') {
				$('#guidelines').hide();
			} else {
				$('#guidelines').show();
			}
		}

		// shift + arrow keys allow navigation through horizontal and vertical slides
		if (e.shiftKey && e.which == 37) {
			Reveal.left();
		}
		if (e.shiftKey && e.which == 39) {
			Reveal.right();
		}
		if (e.shiftKey && e.which == 38) {
			Reveal.up();
		}
		if (e.shiftKey && e.which == 40) {
			Reveal.down();
		}

		// 'j' key reveals positive feedback
		if (e.which === 74) {
			simpleModalClose();
			simpleModalOpen('positive');
		}
		//  'k' key reveals negative feedback 1
		if (e.which === 75) {
			simpleModalClose();
			if (slide.data.modal.negative) {
				simpleModalOpen('negative');
			} else if (slide.data.modal.negative1) {
				simpleModalOpen('negative1');
			}
		}
		// 'l' key reveals negative feedback 2
		if (e.which === 76) {
			simpleModalClose();
			simpleModalOpen('negativeFinal');
		}
		// 1 - 9 for hotspots
		if (e.which === 49 && slide.data.modal.hs1) {
			simpleModalClose();
			simpleModalOpen('hs1');
		}
		if (e.which === 50 && slide.data.modal.hs2) {
			simpleModalClose();
			simpleModalOpen('hs2');
		}
		if (e.which === 51 && slide.data.modal.hs3) {
			simpleModalClose();
			simpleModalOpen('hs3');
		}
		if (e.which === 52 && slide.data.modal.hs4) {
			simpleModalClose();
			simpleModalOpen('hs4');
		}
		if (e.which === 53 && slide.data.modal.hs5) {
			simpleModalClose();
			simpleModalOpen('hs5');
		}
		if (e.which === 54 && slide.data.modal.hs6) {
			simpleModalClose();
			simpleModalOpen('hs6');
		}
		if (e.which === 55 && slide.data.modal.hs7) {
			simpleModalClose();
			simpleModalOpen('hs7');
		}
		if (e.which === 56 && slide.data.modal.hs8) {
			simpleModalClose();
			simpleModalOpen('hs8');
		}
		if (e.which === 57 && slide.data.modal.hs9) {
			simpleModalClose();
			simpleModalOpen('hs9');
		}

		//  ';' key hides all feedbacks
		if (e.which == 186) {
			simpleModalClose();
		}
	});
}
